import { useState } from 'react';
import type { FormDetails } from '@urbanx/agx-ui-components';
import { AgxButton, AgxModal, AgxRadioGroup, AgxSpacer } from '@urbanx/agx.ui-components2';

interface CampaignEntryDialogProps {
  isOpen: boolean;
  setIsDialogOpen: (isOpen: boolean) => void;
  id: string;
  states: FormDetails['state'][];
  onSelect: (state: FormDetails['state']) => void;
}

export const CampaignEntryDialog = ({
  isOpen,
  setIsDialogOpen,
  id,
  states,
  onSelect,
}: CampaignEntryDialogProps) => {
  const [selectedState, setSelectedState] = useState(states.length === 1 ? states[0] : undefined);

  return (
    <AgxModal
      type="single"
      variant="withDivider"
      actionButtonContainerStyle="withoutDivider"
      title="Select the state the property is located in:"
      isOpen={isOpen}
      setIsDialogOpen={setIsDialogOpen}
      content={
        <AgxSpacer direction="vertical" gap="md" padding="xl">
          {states.length === 0 ? (
            <p>No supported property states are available for your agency.</p>
          ) : (
            <AgxRadioGroup
              id={`${id}-states-radio`}
              label="Property state"
              options={states.map((state) => ({ label: state, value: state }))}
              onChange={(value) => setSelectedState(states.find((state) => state === value))}
              layout="vertical"
              value={selectedState}
            />
          )}
        </AgxSpacer>
      }
      actionButtons={
        <AgxSpacer direction="horizontal" gap="md" contentJustification="center" fill>
          <AgxButton
            id={`${id}-states-cancel`}
            text="Cancel"
            variant="hollow"
            size="large"
            onClick={() => setIsDialogOpen(false)}
            stretch
          />
          <AgxButton
            id={`${id}-states-select`}
            text="Select"
            variant="primary"
            size="large"
            disabled={!selectedState}
            onClick={() => {
              if (!selectedState) return;
              onSelect(selectedState);
              setIsDialogOpen(false);
            }}
            stretch
          />
        </AgxSpacer>
      }
    />
  );
};
